<template>
<div class="chapter">
<div class="inner_page">
<h1 class="head1">Leap of Faith</h1>
<p class="head3">An Astronaut’s Journey Into the Unknown</p>
<p class="head3">Gordon Cooper with Bruce Henderson</p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?8272f792